import * as types from '../types';
import { IInventoryApi } from '../contracts';
import { HttpApi } from './HttpApi';

const BASE = '/inventory';

export class InventoryHttpApi extends HttpApi implements IInventoryApi {
  async receiveStock(data: types.ReceiveStockRequest): Promise<types.InventoryChangeResponse> {
    const response = await this.http.post<types.APIResponse<types.InventoryChangeResponse>>(`${BASE}/receive`, data);
    return response.data.data;
  }

  async adjustStock(data: types.AdjustStockRequest): Promise<types.InventoryChangeResponse> {
    const response = await this.http.post<types.APIResponse<types.InventoryChangeResponse>>(`${BASE}/adjust`, data);
    return response.data.data;
  }

  async listInventoryAdjustments(
    page = 1,
    limit = 50,
    filters: types.InventoryAdjustmentListFilters = {}
  ): Promise<types.PaginatedResponse<types.InventoryAdjustment>> {
    // A blank itemId is left out (the server would look up item '').
    const params: Record<string, string | number> = { page, limit };
    if (filters.itemId) params.itemId = filters.itemId;
    const response = await this.http.get<types.PaginatedResponse<types.InventoryAdjustment>>(`${BASE}/adjustments`, { params });
    return response.data;
  }

  async getInventoryValuation(filters: types.InventoryValuationFilters = {}): Promise<types.InventoryValuation> {
    const params: Record<string, string> = {};
    if (filters.lowStock) params.lowStock = 'true';
    const response = await this.http.get<types.APIResponse<types.InventoryValuation>>(`${BASE}/valuation`, { params });
    return response.data.data;
  }
}
